module.exports = __webpack_public_path__ + "img/light_online_on.8581dd16.png";